export default "__VITE_ASSET__D8WlUkFp__"